import React from 'react';
import { useLanguage } from '@/contexts/LanguageContext';

export default function TermsPage() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';
  const displayFont = isAr ? 'var(--font-ar-display)' : 'var(--font-en-display)';

  return (
    <div data-testid="terms-page">
      <section className="bg-gradient-to-br from-[#0B2F44] to-[#071E2C] pt-28 pb-12">
        <div className="max-w-[900px] mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: displayFont }}>
            {isAr ? 'الشروط والأحكام' : 'Terms & Conditions'}
          </h1>
          <p className="text-white/50 mt-3 text-sm">{isAr ? 'آخر تحديث: أبريل 2026' : 'Last updated: April 2026'}</p>
        </div>
      </section>

      <section className="bg-[#F8FAFB] py-16">
        <div className="max-w-[900px] mx-auto px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 lg:p-12 border border-[#D0D8DC]/50 shadow-sm" style={{ lineHeight: isAr ? '2' : '1.8' }}>
            <h2 className="text-lg font-bold text-[#0B2F44]" style={{ fontFamily: displayFont }}>
              {isAr ? '1. الخدمات' : '1. Services'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'جُليد للرهن العقاري (Guleed Mortgage) هي شركة وساطة تمويل عقاري مرخصة في الإمارات. نعمل كوسيط بين العملاء والمؤسسات المالية لتأمين أفضل شروط التمويل العقاري. خدماتنا مجانية للعملاء — البنوك تدفع عمولة الوساطة.'
                : 'Guleed Mortgages Real Estate LLC (Guleed Mortgage) is a licensed mortgage brokerage in the UAE. We act as an intermediary between clients and financial institutions to secure the best mortgage terms. Our services are fee-free for clients — banks pay our brokerage commission.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '2. أسعار التمويل' : '2. Mortgage Rates'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'الأسعار المعروضة على موقعنا هي أسعار إرشادية وقد تختلف بناءً على ملفك المالي ومتطلبات البنك. الأسعار النهائية تُحدد من قبل المؤسسة المالية المقرضة وتخضع لشروط الموافقة.'
                : 'Rates displayed on our website are indicative and may vary based on your financial profile and bank requirements. Final rates are determined by the lending financial institution and subject to approval conditions.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '3. برنامج الإحالة' : '3. Referral Program'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'رسوم الإحالة (0.3%) تُدفع بعد صرف التمويل بنجاح. جُليد تحتفظ بحق تعديل نسبة العمولة بإشعار مسبق 30 يوماً. الشريك مسؤول عن الإفصاح الضريبي على دخل الإحالة.'
                : 'Referral fees (0.3%) are paid after successful mortgage disbursement. Guleed Mortgage reserves the right to modify commission rates with 30 days notice. Partners are responsible for tax disclosure on referral income.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '4. العملات الرقمية' : '4. Digital Assets'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'خدمات تحويل العملات الرقمية تتم عبر بورصات مرخصة ومتوافقة مع تنظيمات VARA. جُليد لا تحتفظ بأي عملات رقمية ولا تقدم نصائح استثمارية بشأن الأصول الرقمية.'
                : 'Crypto conversion services are facilitated through VARA-licensed regulated exchanges. Guleed Mortgage does not hold any cryptocurrency and does not provide investment advice on digital assets.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '5. بوابة العميل' : '5. Client Portal'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'أنت مسؤول عن الحفاظ على سرية بيانات الدخول. جُليد غير مسؤولة عن أي وصول غير مصرح به ناتج عن مشاركة كلمة المرور.'
                : 'You are responsible for maintaining the confidentiality of your login credentials. Guleed Mortgage is not liable for unauthorized access resulting from password sharing.'}
            </p>

            <h2 className="text-lg font-bold text-[#0B2F44] mt-8" style={{ fontFamily: displayFont }}>
              {isAr ? '6. القانون الحاكم' : '6. Governing Law'}
            </h2>
            <p className="text-[#4A6572] text-sm mt-2">
              {isAr
                ? 'تخضع هذه الشروط لقوانين دولة الإمارات العربية المتحدة. أي نزاعات تُحل عبر محاكم أبوظبي.'
                : 'These terms are governed by the laws of the United Arab Emirates. Any disputes shall be resolved through Abu Dhabi courts.'}
            </p>

            <div className="mt-10 pt-6 border-t border-[#D0D8DC]/30 text-center">
              <p className="text-xs text-[#4A6572]">
                Guleed Mortgages Real Estate LLC | 3 Sails Tower, Corniche, Abu Dhabi, UAE
                <br />info@gmreae.com | +971 52 289 8249
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
